import type { VignetteDefinition } from "./types";

/**
 * A common activity — Johnny fishing off the shore. No dedicated "Fish"
 * animation exists yet (the plan's hand-authored MVP action clips were
 * never reached — see docs/Castaway Plan.md Phase 2 status); "Interact"
 * (a generic reach/grab gesture from the sourced animation library) stands
 * in for now. Swap `animationClip` once a real fishing clip is sourced or
 * authored — nothing else about this definition needs to change.
 */
export const fishingVignette: VignetteDefinition = {
  id: "fishing",
  name: "Fishing off the shore",
  category: "common",
  weight: 10,
  animationClip: "Interact",
  loopAnimation: true,
  durationMs: 6000,
  cameraFraming: {
    offset: { x: 3, y: 1.6, z: 2.5 },
    targetOffset: { x: 0, y: 1, z: 0 },
  },
  audioCues: [{ id: "sfx.splash", offsetMs: 1500 }],
  timeOfDay: "any",
};
